module.exports = __webpack_public_path__ + "img/gongshui.da62a860.png";